import 'css-chunk:src/components/widgets/Table/Cell/MediaCell.scss';export default {
  "MediaCell": "_MediaCell_1jukv_1",
  "mediaContent": "_mediaContent_1jukv_1",
  "image": "_image_1jukv_7",
  "Tooltip": "_Tooltip_1jukv_17"
};